/* eslint-disable lingui/no-unlocalized-strings -- отладочная панель, монтируется только вне production */
import { SignalLow, Unplug } from 'lucide-react';
import { DEFAULT_FLAPPING, DEFAULT_POOR_NETWORK } from 'modules/overlay-v2/domain/utils/network-chaos';
import useNetworkChaos from 'modules/overlay-v2/ui/hooks/use-network-chaos';
import { theme } from 'styles/theme/theme';
import Block from '../components/block';
import Text from '../components/text';
import { Button } from './style';

const poorNetworkHint = `${DEFAULT_POOR_NETWORK.minLatencyMs / 1000}–${DEFAULT_POOR_NETWORK.maxLatencyMs / 1000} с, ${Math.round(
  DEFAULT_POOR_NETWORK.lossRate * 100,
)}% потерь`;

const flappingHint = `${DEFAULT_FLAPPING.downMs / 1000} с без связи / ${DEFAULT_FLAPPING.upMs / 1000} с со связью`;

/**
 * Отладочная панель для воспроизведения моргания табло (IMGM-1435). Только вне production.
 *
 * Кнопки ломают транспорт этой вкладки. Данные (смены табло, перезапуск трансляции) меняет
 * приложение, а вместо него — `scripts/overlay-storm.mjs`: из браузера их эмулировать нечестно,
 * оверлей узнаёт обо всём из базы по realtime.
 */
export function NetworkChaos() {
  const { isPoorNetwork, isFlapping, isOffline, togglePoorNetwork, toggleFlapping } = useNetworkChaos();

  return (
    <Block className={'flex flex-col'} headerText={`Эмуляция сети${isOffline ? ' — сейчас без связи' : ''}`}>
      <Button color={isPoorNetwork ? theme.colors.error : theme.colors.Gray} onClick={togglePoorNetwork} className={'flex-center'}>
        <Text size={'medium'} color={'inherit'}>
          {isPoorNetwork ? `Плохой интернет: вкл. (${poorNetworkHint})` : 'Включить плохой интернет'}
        </Text>
        <SignalLow size={14} />
      </Button>
      <Button color={isFlapping ? theme.colors.error : theme.colors.Gray} onClick={toggleFlapping} className={'flex-center'}>
        <Text size={'medium'} color={'inherit'}>
          {isFlapping ? `Обрывы: вкл. (${flappingHint})` : 'Периодически обрывать интернет'}
        </Text>
        <Unplug size={14} />
      </Button>
    </Block>
  );
}

export default NetworkChaos;
